/*
 * Checkbox selection with free text component.
 * This is a composite based on other components.
 */
import React from 'react';

import {
  Mode
} from '../common.jsx';
import Helpers from './helpers.jsx';
import GridLayout from './grid_layout.jsx'
import CheckboxSelection from './checkbox_selection.jsx'
import Selection from './selection.jsx'
import TextField from './text_field.jsx'

export default class CheckboxSelectionWithFreeText extends GridLayout {

        static get CATEGORY() {
            return 'question';
        }

        static get TYPE() {
            return 'checkbox_selection_free_text'
        }

        static icon(){
            return <i><i className="fa fa-check-square"></i> <i className="fa fa-i-cursor"></i></i>;
        }

        static defaultContent(language) {
            let checkComponent = Object.assign(CheckboxSelection.defaultContent(language), {
                name: 'field_' + Helpers.randomString(),
                deletable: false,
                sortable: false
            });

            let otherOptionTranslationKey = Selection.generateOptionTranslationKey();
            checkComponent.options[0].options.push({ value: '0', label: otherOptionTranslationKey });
            checkComponent.translations[language][otherOptionTranslationKey] = I18n.t('field_default_option_other', { scope: 'fe', locale: language });

            let otherComponent = Object.assign(TextField.defaultContent(language), {
                name: checkComponent.name + '_other',
                deletable: false,
                sortable: false
            });
            otherComponent.translations[language] = Object.assign(otherComponent.translations[language], {
                label: '',
                description: '',
                placeholder: I18n.t('please_specify', { scope: 'fe', locale: language })
            });

            return Object.assign(super.defaultContent(language), {
                rows: [
                    [{ span: 1, component: checkComponent }],
                    [{ span: 1, component: otherComponent }]
                ]
            });
        }

        constructor(props) {
            super(props);

            // Ensure old forms have also sortable = false for nested
            // components since that attribute was added later.
            if (this.props.mode == Mode.EDIT) {
                this.constructor.nestedComponents(this.props.content).forEach((c) => {
                    if (typeof c.sortable === 'undefined') {
                        c.sortable = false;
                    }
                });
            }
        }

        componentDidMount() {
            super.componentDidMount();

            if (typeof this.props.updateSettingsCallback == 'function') {
                let content = this.props.content;
                if (content.isNewComponent) {
                    content.rows[0][0].component.isNewComponent = true;
                    content.rows[1][0].component.isNewComponent = true;
                    this.props.updateSettingsCallback(content.id, content, true);
                }
            }
        }

        renderSettings() {
            // No settings
        }
}
